"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroller = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ScrollContext = (0, react_1.createContext)('');
const ScrollProvider = ScrollContext.Provider;
function useScrollKey() {
    const context = (0, react_1.useContext)(ScrollContext);
    if (!context) {
        throw new Error('Scroller context was not found');
    }
    return context;
}
function Scroller(props) {
    const { scrollTo, children } = props;
    const isAllScrollItem = react_1.Children.toArray(children).some((child) => (0, react_1.isValidElement)(child) && child.type === ScrollerElement);
    if (!isAllScrollItem && react_1.Children.count(children) > 0) {
        throw new Error("one of the children should be of type <Scroller.Item elementKey='...' > children </Scroller.Item>");
    }
    return (0, jsx_runtime_1.jsxs)(ScrollProvider, { value: scrollTo, children: [" ", children, " "] });
}
exports.Scroller = Scroller;
function ScrollerElement(props) {
    const { children, elementKey } = props;
    const scrollToKey = useScrollKey();
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (ref.current && elementKey === scrollToKey) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [elementKey, scrollToKey]);
    return (0, jsx_runtime_1.jsx)("div", { ref: ref, children: children });
}
Scroller.Item = ScrollerElement;
